import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { toast } from "react-toastify";
import {
  getPlayerLeaderboard,
  getSeasonPlayerLeaderboard,
} from "../services/leaderboardService";
import { LeaderboardPlayerData } from "../models/leaderboard";

const defaultValues = {
  seasonPlayerLeaderboard: [],
  playerLeaderboard: [],
  isBusy: false,
  leaderboardMatchId: null,
};

interface LeaderboardStore {
  seasonPlayerLeaderboard: LeaderboardPlayerData[];
  playerLeaderboard: any[];
  isBusy: boolean;
  leaderboardMatchId: string | null;
  setLeaderboardMatchId: (matchId: string | null) => void;

  leaderboardLevel: "season" | "match";
  backClicked: boolean;
  setLeaderboardLevel: (level: "season" | "match") => void;

  getPlayerLeaderboard: (matchId: string, force?: boolean) => void;
  getSeasonPlayerLeaderboard: (seasonId: string) => void;
}

export const useLeaderboardStore = create<LeaderboardStore>()(
  devtools(
    (set, get) => ({
      ...defaultValues,
      setLeaderboardMatchId: (matchId: string | null) => {
        set({ leaderboardMatchId: matchId });
      },
      leaderboardLevel: "season",
      backClicked: false,
      setLeaderboardLevel: (level: "season" | "match") => {
        set({ leaderboardLevel: level, backClicked: true });
      },
      getPlayerLeaderboard: async (matchId: string, force: boolean = false) => {
        try {
          set({ isBusy: true });

          const { seasonPlayerLeaderboard } = get();

          if (!force && seasonPlayerLeaderboard.length > 0) {
            const filteredData = seasonPlayerLeaderboard.filter(
              (player: any) => player.matchId === matchId
            );
            set({ playerLeaderboard: filteredData, isBusy: false });
            return;
          }

          const response = await getPlayerLeaderboard(matchId);

          if (response.status && response.status === 200) {
            set({ playerLeaderboard: response.result, isBusy: false });
            return;
          } else {
            set({ playerLeaderboard: [], isBusy: false });
            toast.error(response.message);
          }
        } catch (error) {
          set({ playerLeaderboard: [], isBusy: false });
          console.error("Error fetching Player:", error);
        }
      },
      getSeasonPlayerLeaderboard: async (seasonId: string) => {
        try {
          set({ isBusy: true });
          const response = await getSeasonPlayerLeaderboard(seasonId);

          if (response.status && response.status === 200) {
            set({ seasonPlayerLeaderboard: response.result, isBusy: false });
            return;
          } else {
            set({ seasonPlayerLeaderboard: [], isBusy: false });
            toast.error(response.message);
          }
        } catch (error) {
          set({ seasonPlayerLeaderboard: [], isBusy: false });
          console.error("Error fetching Player:", error);
        }
      },
    }),
    {
      name: "LeaderboardStore",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
